(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Old-Style-Upsell"] && !Shopify.designMode) return;
  try {
    
   document.querySelectorAll(".multi-buy-label").forEach(selector => {
      if(!selector.classList.contains('sold-out')){
      selector.addEventListener('click', event => {
      
        document.querySelectorAll(".multi-buy-label").forEach(el => el.classList.remove("active"));
            document.querySelectorAll(".hidden_data").forEach(vat => vat.classList.remove("active"));

            // Add 'active' class to the clicked element
            selector.classList.add("active");
        let vatField = selector.querySelector(".hidden_data");
            if (vatField) {
                vatField.classList.add("active");
            }
        var available = event.currentTarget.getAttribute("upsell_available")
        var productVariant = event.currentTarget.getAttribute("variant");
         setTimeout(function(){
          var price = selector.querySelector(".multi-buy-price").innerHTML;
        document.querySelector(".checkout-floating-bar .total-price").innerHTML = price;
         },100)
        if(available == "true"){
   
          let conditionSelect = event.currentTarget.querySelector(".condtion");
          if(conditionSelect){
          let orderSelect = event.currentTarget.querySelector(".option-order-now-button");
                let upsellItems = document.querySelectorAll(".upsell-item"); 
                let vatField = event.currentTarget.querySelector(".vat_field"); 
                if (conditionSelect.value === "What is your condition?" && vatField.checked) {
                    upsellItems.forEach(item => item.style.display = "none");
                   document.querySelector(".checkout-floating-bar").style.setProperty("display", "none");
                }
        
          if(!vatField.checked){
            orderSelect.classList.remove('disabled');
          }
        }
        document.querySelector(".order-now-floating-bar").style.setProperty("display", "none");
      
        }else{
        var quantity = event.currentTarget.getAttribute("quantity");
        var data = {
          items: [
            {
              id: productVariant,
              quantity: quantity
            }
          ]
        }
        postAndRedirect(data)
        }
      });
      }
    });
document.querySelectorAll(".option-order-now-button").forEach(button => {
    button.addEventListener("click", function (event) {
        let productVariant = event.currentTarget.getAttribute("variant");
        document.querySelectorAll(".upsell-item").forEach(item => {
            if (item.getAttribute("parent-product") === productVariant) {
                item.style.display = "grid";
                item.scrollIntoView({ behavior: "smooth", block: "start" });
            } else {
                item.style.display = "none";
            }
        });
      document.querySelector(".checkout-floating-bar").style.setProperty("display", "grid");
    });
});

    document.querySelector(".floating-bar-order-button").addEventListener("click", event => {
      document.querySelector(".multi-buy-heading").scrollIntoView(true);
    });

    document.querySelectorAll('.upsell-reject-text, .checkout-button').forEach(selector => {
      selector.addEventListener('click', event => {
        var label = document.querySelector("input.multi-buy-selector:checked + label");
         var vatField = label.querySelector(".vat_field");
    var vatChecked = vatField && vatField.checked; // Check if VAT checkbox is checked
  
     var conditionSelectParent = label.querySelector('.condtion-dropdown');
        if(conditionSelectParent){
        var conditionSelect = conditionSelectParent.querySelector('.condtion')
       var conditionValue = conditionSelect ? conditionSelect.value : null; // Get selected value of condition dropdown
        }

        
        var input = document.querySelector("input.multi-buy-selector:checked");
        var variant = input.getAttribute("value");
        var quantity = input.getAttribute("quantity");
        var data = {
          items: [
            {
              id: variant,
              quantity: quantity
            }
          ]
        }
        if (vatChecked && conditionValue) {
      // Add properties to the item data if both VAT is checked and a condition is selected
      data.items[0].properties = {
        "Condition": conditionValue
      };
    }
        postAndRedirect(data)
      })
    })

    document.querySelectorAll('.upsell-accept-button').forEach(button => {
      button.addEventListener('click', event => {
        var label = document.querySelector("input.multi-buy-selector:checked + label");
        var input = document.querySelector("input.multi-buy-selector:checked");
        var variant = input.getAttribute("value");
        var quantity = input.getAttribute("quantity");
        var upsellVariant = event.target.getAttribute("variant");
           var vatField = label.querySelector(".vat_field");
    var vatChecked = vatField && vatField.checked; // Check if VAT checkbox is checked
         var conditionSelectParent = label.querySelector('.condtion-dropdown');
        if(conditionSelectParent){
        var conditionSelect = conditionSelectParent.querySelector('.condtion')
       var conditionValue = conditionSelect ? conditionSelect.value : null; // Get selected value of condition dropdown
        }

        
        var data = {
          items: [
            {
              id: variant,
              quantity: quantity
            },
            {
              id: upsellVariant,
              quantity: 1
            }
          ]
        }
            if (vatChecked && conditionValue) {
      // Add properties to the item data if both VAT is checked and a condition is selected
      data.items[0].properties = {
        "Condition": conditionValue
      };
    }
        postAndRedirect(data)
      })
    });

   function postAndRedirect(data){
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(cartItem => {
    console.log("Added to cart:", cartItem);

    // Redirect to cart page after adding
    window.location.href = window.Shopify.routes.root + 'cart';
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
  //test

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
